import {
  CollaborationV1ReactionInput,
  CreateReactionMutation,
  CreateReactionMutationVariables,
  ReactionFragment,
  useCreateReactionMutation,
  withStandardCreateHook,
} from '@spotify/confidence-graphql';
import { useCurrentIdentity } from '@spotify/plugin-confidence-iam-react';

import { createReactionCacheUpdate } from './create-reaction-cache-update';

const useCreateReactionImpl = withStandardCreateHook<
  CreateReactionMutation,
  ReactionFragment,
  'createReaction',
  CreateReactionMutationVariables,
  [CollaborationV1ReactionInput, string | undefined]
>(useCreateReactionMutation, 'createReaction', (input, reactionId) => ({
  input,
  reactionId,
}));

export const useCreateReaction: typeof useCreateReactionImpl = options => {
  const { currentIdentity } = useCurrentIdentity();

  return useCreateReactionImpl({
    ...options,
    update: createReactionCacheUpdate(currentIdentity),
  });
};
